export const CircleTextSVG = ({
  fontSize = 125,
  circleDiameter = 2000,
  textOutsideOfCircle = false,
  textTop = false,
  circleCenterX = 1000,
  circleCenterY = 1000,
  text = '',
}) => {
  // Calculate radius and path flipping
  const radius = textOutsideOfCircle
    ? circleDiameter / 2
    : circleDiameter / 2 - 90;

  const flipPath = textOutsideOfCircle ? 1 : 0;

  // Create the SVG path based on whether the text is at the top or bottom
  const pathD = textTop
    ? `M ${circleCenterX},${circleCenterY + radius}
       a ${radius},${radius} 0 1,${flipPath} 0,${-2 * radius}
       a ${radius},${radius} 0 1,${flipPath} 0,${2 * radius}`
    : `M ${circleCenterX},${circleCenterY - radius}
       a ${radius},${radius} 0 1,${flipPath} 0,${2 * radius}
       a ${radius},${radius} 0 1,${flipPath} 0,${-2 * radius}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${circleDiameter} ${circleDiameter}`}
      style={{ fontSize: fontSize }}
    >
      {/* Embed font using a style tag */}
      <style>
        {`

          .text {
            font-family: "NIVEA";
            font-size: ${fontSize}px;
            font-weight: 700;
            letter-spacing: 8px;
            fill: white;
          }
        `}
      </style>

      {/* Create the circular path */}
      <path
        id="textPath"
        d={pathD}
        fill="transparent" /* Optional, can be removed */
        stroke="transparent" /* Optional, can be removed */
      />

      {/* Place the text along the path */}
      <text className="text">
        <textPath
          href="#textPath"
          startOffset="50%"
          method="align"
          // algin the text to the center of the path,
          // middle align in our case the text is centered top or bottom
          textAnchor="middle"
        >
          {text}
        </textPath>
      </text>
    </svg>
  );
};
